<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model.trim="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzyCodeSearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="1013010"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        config-module="1013010"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item ref="serialNumber" :valid="$t('FileHistory.PlsInput')" :label="$t('baseInfo.basicData.currency.serialNumber')">
            <el-input-number
              v-model="editDialog.form.serialNumber"
              no="serialNumber"
              disabled
              :min="0"
              :controls="false"
              size="mini"
              style="width: 172.7px"
              @blur="serialNumberBlur"
            />
          </el-form-item>
          <el-form-item ref="code" :valid="$t('FileHistory.PlsInput')" :label="$t('CargoMsg.Cargo_Code')">
            <el-input v-model="editDialog.form.code" no="code" :disabled="isTenant" />
          </el-form-item>
          <el-form-item ref="type" :valid="$t('CargoMsg.Cargo_PleaseSelect')" :label="$t('CargoMsg.Cargo_Type')">
            <el-select v-model="editDialog.form.type" no="type" :disabled="isTenant">
              <el-option
                v-for="item in airplaneContainerTypes"
                :key="item.code"
                :label="item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_DeadWeight') + '(KG)'">
            <el-input-number v-model="editDialog.form.selfWeight" no="selfWeight" :disabled="isTenant" style="width: 172.7px" :controls="false" />
          </el-form-item>
          <el-form-item
            ref="cargoWeight"
            :valid="$t('FileHistory.PlsInput')"
            :label="$t('CargoMsg.Cargo_LoadableWeight') + '(KG)'"
          >
            <el-input-number v-model="editDialog.form.cargoWeight" no="cargoWeight" :disabled="isTenant" style="width: 172.7px" :controls="false" />
          </el-form-item>
          <el-form-item
            :label="$t('CargoMsg.Cargo_LoadableCapacity') + '(m³)'"
          >
            <el-input-number v-model="editDialog.form.cargoCapacity" no="cargoCapacity" :disabled="isTenant" style="width: 172.7px" :controls="false" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Size')">
            <div class="size" style="display: flex" />
            <el-input-number v-model="editDialog.form.length" no="length" :disabled="isTenant" style="width: 50px !important;" :placeholder="$t('Warehouse.boxLengthPlaceholder')" :controls="false" />
            <span> * </span>
            <el-input-number v-model="editDialog.form.width" no="width" :disabled="isTenant" style="width: 50px !important;" :placeholder="$t('Warehouse.boxWidthPlaceholder')" :controls="false" />
            <span> * </span>
            <el-input-number v-model="editDialog.form.height" no="height" :disabled="isTenant" style="width: 50px !important;" :placeholder="$t('Warehouse.BoxHeightPlaceholder')" :controls="false" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ApplicableModels')">
            <el-input v-model="editDialog.form.applicableModels" no="applicableModels" :disabled="isTenant" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.currency.remarks')">
            <el-input v-model="editDialog.form.remark" no="remark" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('CargoMsg.Cargo_Add')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-airplane-container />
      <span slot="footer">
        <el-button no="save" type="primary" @click="addFromPlatform">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { getAirplaneContainerList, getAirplaneContainersByPlatform, saveAirplaneContainer, addAirplaneContainerByPlatform, saveAirplaneContainers, delAirplaneContainer } from '@/api/basicData/airplaneContainer'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DataCheckUtil } from '@/class/cargo/model/utils/DataCheckUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import BaseAirplaneContainer from '@/views/cargo/v0/Information/components/basicData/baseAirplaneContainer'
import { deepClone } from '@/utils'

export default {
  name: 'AirplaneContainer',
  components: { BaseAirplaneContainer },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.serialNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Type'),
          field: 'type',
          width: 150,
          valueFormatter: (params) => {
            return CommonState.getNameByCode(SystemConstants.AIRPLANE_CONTAINER_TYPES, params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DeadWeight') + '(KG)',
          field: 'selfWeight',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LoadableWeight') + '(KG)',
          field: 'cargoWeight',
          width: 100,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LoadableCapacity') + '(m³)',
          field: 'cargoCapacity',
          width: 120,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Size'),
          field: 'length',
          width: 100,
          hide: true,
          valueFormatter: (params) => {
            return params.value + ' * ' + params.data.width + ' * ' + params.data.height
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableModels'),
          field: 'applicableModels',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.currency.remarks'),
          field: 'remark',
          width: 150
        }
      ],
      rowData: null,
      tenantId: '',
      airplaneContainerTypes: SystemConstants.AIRPLANE_CONTAINER_TYPES,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNumber: '',
          code: '',
          cargoCapacity: 0.0,
          cargoWeight: 0.0,
          width: 0.0,
          length: 0.0,
          height: 0.0,
          type: '',
          selfWeight: 0.0,
          applicableModels: '',
          remark: ''
        }
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isTenant() { // 是否租户
      return this.$store.getters.tenantId > 1
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getAirplaneContainerList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getAirplaneContainersByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          serialNumber: this.total + 1,
          code: '',
          cargoCapacity: 0.0,
          cargoWeight: 0.0,
          width: 0.0,
          length: 0.0,
          height: 0.0,
          type: '',
          selfWeight: 0.0,
          applicableModels: '',
          remark: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_maintenance')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_Please_Select_The_Uld_You_Want_To_Edit'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.form.serialNumber = this.editDialog.form.serialNumber ? this.editDialog.form.serialNumber : 1
        this.editDialog.title = this.$t('CargoMsg.Cargo_maintenance')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (DataCheckUtil.checkForm(this.$refs, form, this)) {
        return
      }
      let saveFunc = saveAirplaneContainer
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addAirplaneContainerByPlatform
      }
      saveFunc(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_Please_Select_The_Uld_To_Be_Deleted'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const keys = Array.from(rows, p => p.uuid)
        delAirplaneContainer(keys).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBaseAirplaneContainer) {
        document.resetBaseAirplaneContainer()
      } else {
        setTimeout(() => {
          document.resetBaseAirplaneContainer()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseAirplaneContainerRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push(deepClone(item))
      }
      saveAirplaneContainers(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
